// ─── Design tokens ─────────────────────────────────────────────────────────
// Single source of truth for colors and shadows.
// Import COLORS directly instead of hardcoding hex values in components.
export const COLORS = {
  // ── Gold palette ──────────────────────────────────────────────────────────
  goldGrad:         'linear-gradient(#f0c876 0%, #b47806 100%)',
  gold:             '#c4980e',   // mid-gold – eyebrow text, borders, active
  goldLight:        '#f0c876',   // light gold – gradient start
  goldDark:         '#b47806',   // dark gold – gradient end
  goldSoft:         '#e8d28a',   // soft gold – text on dark backgrounds
  goldInk:          '#0e0906',   // near-black – text on gold buttons

  // ── Dark backgrounds ──────────────────────────────────────────────────────
  dark:             '#07101f',   // page hero / app background
  darkDeep:         '#0a0c10',
  darkSection:      'linear-gradient(140deg, #0d2248 0%, #162e58 55%, #0d2248 100%)',
  darkAlt:          'linear-gradient(145deg, #0f1928 0%, #1c2237 50%, #17253d 100%)',
  footer:           '#1c2237',

  // ── Light / bone surfaces ────────────────────────────────────────────────
  bone:             '#f2ede4',   // warm ivory – light section bg
  boneAlt:          '#f5f7fb',
  white:            '#ffffff',

  // ── Borders ───────────────────────────────────────────────────────────────
  borderLight:      '#e2e8f0',
  borderGold:       'rgba(240,200,118,.22)',
  borderGoldStrong: 'rgba(196,152,14,.4)',

  // ── Status / semantic (keep green for live indicators) ────────────────────
  liveGreen:        '#16a34a',
  success:          '#4ade80',
  danger:           '#dc2626',
  muted:            '#7d7673',

  // ── Shadows ───────────────────────────────────────────────────────────────
  shadowCta: '0 16px 36px -10px rgba(139,94,0,.7), 0 0 0 1px rgba(139,94,0,.55) inset, 0 1px 0 rgba(255,255,255,.22) inset',
  shadowSm:  '0 4px 20px rgba(180,120,6,.4)',
  shadowMd:  '0 8px 32px rgba(180,120,6,.6)',
};

// ─── App branding ───────────────────────────────────────────────────────────
export const BRANDING = {
  appName: 'Proven Winner Predict',
  tagline: 'Game card predictions and props built for serious bettors.',
  companyName: 'ProvenWinner',
  privacyPolicyUrl: 'https://www.provenwinner.net/privacy',
  supportEmail: 'support@replace-with-domain.com',
  logoPath: '/img/logo.png',
  iconPath: '/img/icon.png',
  primaryColor: COLORS.gold,
  darkColor: COLORS.dark,
  accentColor: COLORS.goldLight,
  seo: {
    siteUrl: 'https://replace-with-domain.com',
    defaultTitle: 'Proven Winner Predict',
    defaultDescription: 'Game cards, score predictions, Proven Line, PW Rating, and player props.',
    ogImage: 'https://replace-with-domain.com/img/logo.png'
  },
  packages: {
    plans: [
      { id: 'essential', label: 'Essential', monthlyCredits: 20, monthlyPrice: '$29' },
      { id: 'plus', label: 'Plus', monthlyCredits: 60, monthlyPrice: '$69' },
      { id: 'pro', label: 'Pro', monthlyCredits: 150, monthlyPrice: '$149' },
      { id: 'elite', label: 'Elite', monthlyCredits: 400, monthlyPrice: '$299' }
    ],
    topUps: [
      { id: 'starter', label: 'Starter Top-Up', credits: 20 },
      { id: 'standard', label: 'Standard Top-Up', credits: 60 },
      { id: 'pro', label: 'Pro Top-Up', credits: 150 },
      { id: 'elite', label: 'Elite Top-Up', credits: 400 }
    ]
  }
};
